import chalk from 'chalk'
import inquirer, { Question } from 'inquirer'

import { CircleApiUtils, circleApiQuestions, displayEnvList } from '../utils'

const askQuestions = inquirer.prompt

const listCircleEnvs = async (questions: Question[]) => {
  try {
    console.info(`${chalk.green('Listing CircleCI envs in given project')} \n`)
    const answers = await askQuestions(questions)
    const utils = new CircleApiUtils({ token: answers.circleToken, projectSlug: answers.projectSlug })
    const envs = await utils.getAllEnvs()

    displayEnvList(envs)
  } catch (error) {
    console.error(error.message)
  }
}

export const command = 'list'
export const desc = 'List CircleCI envs for a project'
export const handler = async (): Promise<void> => listCircleEnvs(circleApiQuestions)
